<template>
  <div id="app">

    <div>

      <div style="padding: 1rem .625rem 2.5rem .625rem;text-align: left;position: relative;">
        <div class="fc-FFFFFF-fs-la-m" style="color: #202021;">不难得移动端</div>
        <div class="fc-FFFFFF-fs-nor-r" style="margin-top: .3275rem;color: #999999">欢迎注册成为不难得用户</div>


        <form class="form-box" style="padding: 0 .625rem;margin-top: 1.125rem;padding-right: 0;" >
          <div class="cus-row cus-row-v-m" v-if="login_type == 1">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/mobile.png" style="width: 0.625rem"/></div>
            <div class="cus-row-col-9" style="padding:0 .2rem;box-sizing: border-box"> <input placeholder="请输入用户名或手机号" class="fc-333333-fs-nor-r cus-input" style="border: none;" v-model="phone" ></div>
            <div class="cus-row-col-2 t-al-r" style="box-sizing: border-box;font-size: .5rem !important;"><span style="line-height: 1.844rem;display: inline-block">&nbsp;</span>
              <i v-if="phone" style="margin-right: .5rem;">
                <van-icon name="clear" @click="clearPhone" :style="{'font-size':'0.5rem','color':'#a0a1a7','vertical-align':'middle'}"/>
              </i>
            </div>
          </div>


          <div class="cus-row cus-row-v-m" v-if="login_type == 2">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/mobile.png" style="width: 0.625rem"/></div>
            <div class="cus-row-col-9" style="padding:0 .2rem;box-sizing: border-box"> <input placeholder="请输入手机号" class="fc-333333-fs-nor-r cus-input" style="border: none;" v-model="mobile" type="number"></div>
            <div class="cus-row-col-2 t-al-r" style="box-sizing: border-box;font-size: .5rem !important;"><span style="line-height: 1.844rem;display: inline-block">&nbsp;</span>
              <i v-if="mobile" style="margin-right: .5rem;">
                <van-icon name="clear" @click="clearMobile" :style="{'font-size':'0.5rem','color':'#a0a1a7','vertical-align':'middle'}"/>
              </i>
            </div>
          </div>

          <div style="border-bottom: 1px solid #E5E5E5;margin-left: -0.625rem;"></div>

          <div class="cus-row cus-row-v-m" v-if="login_type == 1">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/safety_certificate.png" style="width: 0.625rem;"/></div>
            <div class="cus-row-col-9" style="overflow: hidden;box-sizing: border-box;padding:0 .2rem;">  <input v-model="password"  placeholder="请输入密码" class="fc-333333-fs-nor-r cus-input" style="border: none;" type="password"/> </div>
            <div class="cus-row-col-2 t-al-r" style="box-sizing: border-box;font-size: .5rem !important;"><span style="line-height: 1.844rem;display: inline-block">&nbsp;</span>
              <i v-if="sms_code" style="margin-right: .5rem;">
                <van-icon name="clear" @click="clearPassword" :style="{'font-size':'0.5rem','color':'#a0a1a7','vertical-align':'middle'}"/>
              </i>
            </div>
          </div>



          <div class="cus-row cus-row-v-m" v-if="login_type == 2">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/safety_certificate.png" style="width: 0.625rem;display: inline-block"/></div>

            <div class="cus-row-col-7" style="border-right: 1px solid #e5e5e5;overflow: hidden;box-sizing: border-box;padding:0 .2rem;">  <input v-model="sms_code"  placeholder="6位手机验证码" class="fc-333333-fs-nor-r cus-input" style="border: none;" type="number" oninput="if(value.length>6)value=value.slice(0,6)"/> </div>

            <div class="cus-row-col-4 t-al-c" style="">
              <span v-if="second != 60" ><a class="get-code-btn" href="javascript:void(0)" @click="goSms"><span class="fc-1889F9-fs-nor-m " style="line-height: 1.844rem;" v-bind:class="{disableText:second > 0}">{{smsText}}</span></a></span>
              <div class="in-bl" style="line-height: 1.844rem" v-else><van-loading/></div>
            </div>

          </div>
        </form>

        <div style="margin-top: 1.5rem;" class="in-bl-line">
          <a class="bt" href="javascript:void(0);" v-on:click="nextStep" v-bind:class="{'inEdit':!nextStepValid}">登录</a>
        </div>

        <!--                <div class="t-al-c" style="color: rgb(153, 153, 153);"><a href="/sa_find_password" class="fc-FFFFFF-fs-nor-r" style="color: rgb(153, 153, 153);text-decoration:underline;line-height: .7rem;padding: 0 .5rem;">找回密码</a></div>-->

        <!--                <div class="t-al-c fc-FFFFFF-fs-nor-r" style="color: rgb(153, 153, 153);position: fixed;left: 0;right: 0;bottom: 1.5rem;">找回密码</div>-->
      </div>

    </div>



  </div>
</template>


<script>
import common from '../assets/js/common'
import {Toast} from "vant";

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function(){
    return {
      phone:'',
      second:'',
      smsText:'获取验证码',
      sms_code:'',
      pageInit:false,
      eduName:'',
      login_type: 2,
      password: '',
      mobile: '',
      uper: ''
    }
  },
  methods:{
    changeLoginType()
    {
      if( this.login_type == 1)
      {
        this.login_type = 2
      } else
      {
        this.login_type = 1
      }
    },
    goSms(){
      if(!(/^1[3|4|5|8|7][0-9]\d{8}$/.test(this.mobile))) {
        common.mAlert(this,'请输入正确的手机号');
        return;
      }

      if ( this.second ) {
        return;
      }


      this.second = 60;
      this.smsText = this.second + '秒';

      let countDownHandler = '';

      (function(a){
        countDownHandler = setInterval(function(){
          a.second = a.second - 1;
          if( a.second < 1) {
            clearInterval(countDownHandler);
            a.second = 0;
            a.smsText = '获取验证码';
            return;
          }
          a.smsText = a.second + '秒';
        },1000);
      })(this);

      //TODO:请求验证码


      this.$http.get(common.dynamicHost() + '/boot/auth.php',{mobile:this.mobile, action:'reg_sms'}).then((res)=>{
        res = JSON.parse(res.data)
        if( res.status )
        {
          common.mAlert(this,'发送成功')
        }else
        {

          common.mAlert(this, res.desc)
          if( this.second ) {
            try {
              this.second = 0;
              this.smsText = '获取验证码';
              clearInterval(countDownHandler);
            } catch (e) {

            }
          }
        }
      }).catch(err=>{

      });
    },
    nextStep(){


      let phone = (this.login_type == 1)?this.phone:this.mobile;

      if( (this.login_type == 1) && !this.phone )
      {
        common.mAlert(this,'请输入手机号或用户名')
        return;
      }

      if( (this.login_type == 2) && !this.mobile )
      {
        common.mAlert(this,'请输入手机号')
        return;
      }


      if( (this.login_type == 1) && !this.password )
      {
        common.mAlert(this,'请输入密码')
        return;
      }

      if( (this.login_type == 2) && !this.sms_code )
      {
        common.mAlert(this,'请输入验证码')
        return;
      }


      Toast.loading({
        duration: 0,
        mask: true,
        message: '提交中...'
      });

      this.$http.get(common.dynamicHost() + '/boot/auth.php',{mobile:phone,password:this.password, sms_code: this.sms_code, role_limit:'sale', with_info: 1, login_type: this.login_type, action: 'reg_verify_sms', uper: this.uper}).then((res)=>{
        Toast.clear();
        res = JSON.parse(res.data)
        if( res.status )
        {
          location.href = '/mvue/dist'
        } else
        {
          common.mAlert(this,res.desc)
          // this.$layer.msg(res.data.desc);
        }
      }).catch(err=>{
        Toast.clear();
        common.mAlert(this, '服务异常')
      });
    },
    clearPhone()
    {
      this.phone = ''
    },
    clearMobile()
    {
      this.mobile = ''
    },
    clearPassword()
    {
      this.sms_code = ''
    }
  },
  created:function()
  {
  },
  mounted:function(){
    this.uper = this.$route.query.uper
    this.$store.commit('setTarbarShow',0)
  },
  computed:{
    btn_lock:function()
    {

      if((/^1[0-9]\d{9}$/.test(this.phone)) && /^\d{6}$/.test(this.sms_code)) {
        return false ;
      }

      return true;
    },
    nextStepValid:function () {
      if( !this.phone )
      {
        return false;
      }

      if( !this.sms_code )
      {
        return false;
      }

      return true;
    },
    loginText:function()
    {
      if( this.login_type == 1 )
      {
        return '短信验证码登录'
      } else
      {
        return '密码登录'
      }
    }
  }
}
</script>
<style scoped>
.fc-333333-fs-nor-r
{
  background: none !important;
}
</style>
<style>
html,body{background: #ffffff !important;}
html{min-height: 100%}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.in-bl{display: inline-block;}


.form-box
{
  border-radius: 0.3rem;
  border: solid 1px #e4e4e4;
}

a{
  text-decoration: none;
}
</style>
